import { useState } from "react";

import { useIntl } from "react-intl";

import { useCountdown } from "@shared/libs/date-time";

import { resendButtonMessages } from "../ui/messages";

type Props = {
  blockedUntil: Date | string;
  onResend: () => Promise<void>;
};

/**
 * Пропсы кнопки повторной отправки по дедлайну блокировки.
 * Кнопка заблокирована, пока дедлайн не прошел; остаток округляем вверх,
 * чтобы кнопка не открывалась на последней неполной секунде.
 */
export const useResendButton = ({ blockedUntil, onResend }: Props) => {
  const { formatMessage } = useIntl();
  const { ms } = useCountdown(blockedUntil);
  const [isLoading, setIsLoading] = useState(false);

  const isBlocked = ms > 0;

  const onClick = async () => {
    setIsLoading(true);
    try {
      await onResend();
    } finally {
      setIsLoading(false);
    }
  };

  return {
    disabled: isBlocked,
    label: isBlocked
      ? formatMessage(resendButtonMessages.blocked, {
          seconds: Math.ceil(ms / 1000),
        })
      : formatMessage(resendButtonMessages.resend),
    isLoading,
    onClick,
  };
};
